import { render, staticRenderFns } from "./SidebarMenuMain.vue?vue&type=template&id=340b3832&"
import script from "./SidebarMenuMain.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports